import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "../i18n";
import { MADANG_URL } from "./externalApps";
import "../css/launcher.css";

/**
 * 헤더 오른쪽 둥근 버튼. 바로 이동하지 않고 서비스 두 개를 펼친다.
 *   - 마우스: 버튼에 올리면 열리고, 선택지에 올리면 그 칸이 아래로 늘어나며 화면 미리보기를 보여 준다.
 *   - 터치: 마우스를 올릴 수 없어 버튼을 눌러 열고, 미리보기는 처음부터 펼쳐 둔다(launcher.css).
 *
 * Madang 은 다른 서버의 별도 앱(propmate.kr/madang/app)이라 라우터 밖이다.
 * 그래서 <Link> 가 아니라 <a href> 로 전체 이동한다(주소는 externalApps.js).
 */

const SERVICES = [
    {
        key: "map",
        title: "PROPMATE 지도",
        desc: "토지 정보·건축 가능 규모·공사비를 지도에서 확인",
        img: "images/launcher/preview_map.jpg",
        to: "/map",
    },
    {
        key: "madang",
        title: "Madang",
        desc: "대지 분석부터 매스·평면까지 AI 건축 설계",
        img: "images/launcher/preview_madang.jpg",
        href: MADANG_URL,
    },
];

// 마우스 없는 기기인가. 이때만 버튼 누름으로 여닫는다(마우스 기기는 CSS :hover 로 연다).
const isTouchOnly = () =>
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(hover: none)").matches;

const ServiceLauncher = ({ hoverClass = "" }) => {
    const t = useT();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // 열린 채 바깥을 누르면 닫는다.
    useEffect(() => {
        if (!open) return;
        const close = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("pointerdown", close);
        return () => document.removeEventListener("pointerdown", close);
    }, [open]);

    const toggle = (e) => {
        // 패널 안(선택지)을 누른 건 링크가 처리한다.
        if (e.target.closest(".launcher_panel")) return;
        if (isTouchOnly()) setOpen((v) => !v);
    };

    return (
        <div
            ref={ref}
            className={`btns btn_map ${hoverClass} ${open ? "open" : ""}`}
            role="button"
            tabIndex={0}
            aria-haspopup="true"
            aria-expanded={open}
            onClick={toggle}
        >
            <img
                src={process.env.PUBLIC_URL + "images/icon_map_go.png"}
                alt=""
            ></img>
            <div className="hover_box">{t("서비스 바로가기")}</div>
            <div className="launcher_panel">
                <ul className="launcher_list">
                    {SERVICES.map((s) => {
                        const body = (
                            <>
                                <span className="launcher_head">
                                    <strong className="launcher_title">
                                        {t(s.title)}
                                    </strong>
                                    <span className="launcher_arrow" aria-hidden="true">
                                        →
                                    </span>
                                    <span className="launcher_desc">
                                        {t(s.desc)}
                                    </span>
                                </span>
                                <span className="launcher_preview">
                                    <span>
                                        <img
                                            src={process.env.PUBLIC_URL + s.img}
                                            alt={t("{name} 화면 미리보기", {
                                                name: t(s.title),
                                            })}
                                            loading="lazy"
                                        />
                                    </span>
                                </span>
                            </>
                        );
                        return (
                            <li key={s.key} className={`launcher_item ${s.key}`}>
                                {s.to ? (
                                    <Link className="launcher_link" to={s.to}>
                                        {body}
                                    </Link>
                                ) : (
                                    <a className="launcher_link" href={s.href}>
                                        {body}
                                    </a>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default ServiceLauncher;
